import React, { Component } from 'react'

import classNames from './ConstraintsForm.css'
import ArrayPicker from './ArrayPicker'
import Toggle from '../Toggle'
import ToggleForm from '../ToggleForm'
import LocationPicker from '../search/LocationPicker'
import { MONTH_ARRAY, WEATHER_ARRAY } from '../../constants'

const HOUR_OF_DAY_ARRAY = [...Array(24).keys()]
const DATE_ARRAY = [...Array(32).keys()].slice(1)
const DAY_ARRAY = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export default class ConstraintsForm extends Component {
  render () {
    const { values, update, renderHeading, showLocationPicker, title } = this.props
    const renderToggle = key => {
      return (
        <button onClick={() => update(key, !values[key] || undefined)} className={classNames.toggle}>
          <Toggle value={values[key]} />
          {values[key] ? ' Start and finish in this period' : ' Start in this period'}
        </button>
      )
    }
    return (
      <div>
        <div className={classNames.title}>
          {title}
        </div>
        <ToggleForm
          showLabel='Apply a viewing time period'
          description='Limits will ensure the album or playlist is played only within a certain period of time or weather.'
          indicatorValues={[ values.limitHour, values.limitDate, values.limitDay, values.limitMonth, values.limitWeather ]}>
          {renderHeading('View during time of day', renderToggle('limitHourStartEnd'))}
          <ArrayPicker
            array={HOUR_OF_DAY_ARRAY}
            selected={values.limitHour}
            onChange={array => update('limitHour', array)}
          />
          {renderHeading('View during day of month', renderToggle('limitDateStartEnd'))}
          <ArrayPicker
            array={DATE_ARRAY}
            selected={values.limitDate}
            onChange={array => update('limitDate', array)}
          />
          {renderHeading('View during day of week', renderToggle('limitDayStartEnd'))}
          <ArrayPicker
            array={DAY_ARRAY}
            selected={values.limitDay}
            onChange={array => update('limitDay', array)}
          />
          {renderHeading('View during month', renderToggle('limitMonthStartEnd'))}
          <ArrayPicker
            array={MONTH_ARRAY}
            selected={values.limitMonth}
            onChange={array => update('limitMonth', array)}
          />
          {renderHeading('View during weather')}
          <ArrayPicker
            array={WEATHER_ARRAY}
            selected={values.limitWeather}
            onChange={array => update('limitWeather', array)}
          />
        </ToggleForm>
        <ToggleForm
          showLabel='Apply a fixed schedule'
          description='Schedules allow you to schedule an album or playlist to play at a certain time, or when a certain weather type occurs.'
          indicatorValues={[ values.scheduleHour, values.scheduleDate, values.scheduleDay, values.scheduleMonth, values.scheduleWeather ]}>
          {renderHeading('Schedule at time of day')}
          <ArrayPicker
            array={HOUR_OF_DAY_ARRAY}
            selected={values.scheduleHour}
            onChange={array => update('scheduleHour', array)}
          />
          {renderHeading('Schedule on day of month')}
          <ArrayPicker
            array={DATE_ARRAY}
            selected={values.scheduleDate}
            onChange={array => update('scheduleDate', array)}
          />
          {renderHeading('Schedule on day of week')}
          <ArrayPicker
            array={DAY_ARRAY}
            selected={values.scheduleDay}
            onChange={array => update('scheduleDay', array)}
          />
          {renderHeading('Schedule on month')}
          <ArrayPicker
            array={MONTH_ARRAY}
            selected={values.scheduleMonth}
            onChange={array => update('scheduleMonth', array)}
          />
          {renderHeading('Schedule on weather')}
          <ArrayPicker
            array={WEATHER_ARRAY}
            selected={values.scheduleWeather}
            onChange={array => update('scheduleWeather', array)}
          />
        </ToggleForm>
        {showLocationPicker &&
          <div>
            {renderHeading('Set location for dynamic links (if any)')}
            <select
              value={values.locationOverride || undefined}
              onChange={e => update('locationOverride', e.target.value || undefined)}
            >
              <option value={undefined}>Use locations set in albums</option>
              <option value='user'>Override all with default location ({this.props.userDefaultLocation})</option>
              <option value='custom'>Override all with custom location</option>
            </select>
            {values.locationOverride === 'custom' &&
              <LocationPicker
                value={values.location}
                onChange={value => update('location', value)}
                disabled={!values.locationOverride}
                hideMap
              />
            }
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/ConstraintsForm.js